export const SUBSCRIPTION_STATUSES = [
  "ACTIVE",
  "PAUSED",
  "UNPAID",
  "DISABLED",
  "PENDING",
] as const;

export type SubscriptionStatus = (typeof SUBSCRIPTION_STATUSES)[number];

export const SUBSCRIPTION_STATUS_LABEL: Record<SubscriptionStatus, string> = {
  ACTIVE: "Activa",
  PAUSED: "Pausada",
  UNPAID: "Impagada",
  DISABLED: "Deshabilitada",
  PENDING: "Pendiente",
};

export const SUBSCRIPTION_STATUS_STYLES: Record<
  SubscriptionStatus,
  { bg: string; fg: string }
> = {
  ACTIVE: { bg: "#d4edda", fg: "#155724" },
  PAUSED: { bg: "#fff3cd", fg: "#856404" },
  UNPAID: { bg: "#fde2e2", fg: "#b32424" },
  DISABLED: { bg: "#e9ecef", fg: "#495057" },
  PENDING: { bg: "#e7f1ff", fg: "#0a58ca" },
};

export type SubscriptionListRow = {
  subscriptionId: string;
  status: SubscriptionStatus | string;
  createdAt: string | null;
  purchaseDate: string | null;
  effectDate: string | null;
  renewalDate: string | null;
  carrier: string | null;
  capital: number | null;
  frequency: string | null;
  paymentMethod: string | null;
  defaultPaymentMethod: string | null;
  stripeCustomerId: string | null;
  leadId: number | null;
  leadUlid: string | null;
  leadEmail: string | null;
  leadName: string | null;
  leadMarket: string | null;
  leadDni: string | null;
  policyNumber: string | null;
};

export type SubscriptionListResponse = {
  rows: SubscriptionListRow[];
  total: number;
  limit: number;
  offset: number;
};
